import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Mail } from "lucide-react";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await forgotPassword(email);
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <aside className="hero-dark relative hidden lg:flex flex-col justify-between p-12 xl:p-16 text-[#F1EDE4]">
        <Logo variant="light" size="lg" />
        <div>
          <h1 className="font-display text-5xl xl:text-6xl leading-[0.98]">
            Recupere el acceso a <span className="text-[#C19B6C]">su despacho.</span>
          </h1>
          <p className="mt-6 max-w-lg text-[#D4C7B8]">
            Le enviaremos instrucciones para restablecer su contraseña de forma segura.
          </p>
        </div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#8A7563]">
          © {new Date().getFullYear()} · San José, Costa Rica
        </div>
      </aside>

      <main className="paper flex items-center justify-center p-6 sm:p-10 lg:p-16">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo variant="dark" /></div>

          <h2 className="font-display text-3xl">Recuperar contraseña</h2>
          <p className="mt-1 text-sm text-[#6B5D57]">
            Ingrese su correo electrónico y le enviaremos las instrucciones.
          </p>

          {sent ? (
            <div
              data-testid="forgot-sent-message"
              className="mt-8 rounded-md bg-white border border-[#E5DFD3] p-4 text-sm text-[#1A0810]"
            >
              Si el correo existe en nuestro sistema, recibirá un enlace para restablecer su contraseña.
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-8 space-y-5">
              <div>
                <label className="text-[10px] uppercase tracking-[0.22em] text-[#6B5D57] font-semibold">Correo electrónico</label>
                <div className="mt-2 relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6B5D57]" strokeWidth={1.8} />
                  <Input
                    type="email" required
                    data-testid="forgot-email-input"
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    className="h-12 pl-10 bg-white border-[#E5DFD3] focus-visible:ring-[#7A1E2E]"
                    placeholder="usted@bufete.cr"
                  />
                </div>
              </div>
              <Button
                type="submit" disabled={loading}
                data-testid="forgot-submit-button"
                className="w-full h-12 bg-[#2B0913] hover:bg-[#4A0E1C] text-[#F1EDE4]"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar instrucciones"}
              </Button>
            </form>
          )}

          <p className="mt-8 text-center text-sm text-[#6B5D57]">
            <Link to="/login" data-testid="back-to-login-link" className="text-[#C25A5A] hover:text-[#7A1E2E] font-medium">
              ← Volver a iniciar sesión
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
